import { useEffect, useState } from 'react';

const canMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const getInitialMatch = (query, defaultValue) => {
  if (!canMatchMedia()) return defaultValue;
  try {
    return window.matchMedia(query).matches;
  } catch (err) {
    return defaultValue;
  }
};

const useDeviceDetect = (query, defaultValue = false) => {
  const [matches, setMatches] = useState(() => getInitialMatch(query, defaultValue));

  useEffect(() => {
    if (!canMatchMedia()) return undefined;
    let mediaQueryList;
    try {
      mediaQueryList = window.matchMedia(query);
    } catch (err) {
      return undefined;
    }

    const updateMatch = (event) => setMatches(event.matches);

    setMatches(mediaQueryList.matches);

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', updateMatch);
      return () => mediaQueryList.removeEventListener('change', updateMatch);
    }

    if (typeof mediaQueryList.addListener === 'function') {
      mediaQueryList.addListener(updateMatch);
      return () => mediaQueryList.removeListener(updateMatch);
    }

    return undefined;
  }, [query]);

  return matches;
};

export const useMaxWidth = (widthPx, defaultValue = false) => {
  const query = `(max-width: ${widthPx}px)`;
  return useDeviceDetect(query, defaultValue);
};

export const useMinWidth = (widthPx, defaultValue = false) => {
  const query = `(min-width: ${widthPx}px)`;
  return useDeviceDetect(query, defaultValue);
};

export const useIsMobile = (breakpoint = 640, defaultValue = false) => useMaxWidth(breakpoint, defaultValue);

export default useDeviceDetect;
